import * as React from "react"
import Layout from "../components/layout"
import Seo from "../components/Seo"
import gfm from "remark-gfm"
import ReactMarkdown from "react-markdown"
import { graphql } from "gatsby"
import { Container } from "react-bootstrap"

const RJNNetwork = ({ data }) => {
  const {
    strapiRnjNetworkPage: { content },
  } = data

  return (
    <Layout>
      <Seo Sitetitle="RJN Network" />
      <div className="content-body">
        <Container>
          <ReactMarkdown remarkPlugins={[gfm]} className="content">
            {content}
          </ReactMarkdown>
        </Container>
      </div>
    </Layout>
  )
}

export const query = graphql`
  {
    strapiRnjNetworkPage {
      content
    }
  }
`

export default RJNNetwork
